/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum GAEventName {
    AddPaymentInfo = "add_payment_info",
    AddShippingInfo = "add_shipping_info",
    AddToCart = "add_to_cart",
    BeginCheckout = "begin_checkout",
    Purchase = "purchase",
    SelectItem = "select_item",
    ViewItem = "view_item",
}
